import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import CloseDialogButton from 'common/components/Buttons/CloseDialogButton';
import { PLAN_UPDATE_BUTTON_PARAMS, RUNNING_STATE } from 'common/utils/constants';
import { getInstanceByStrategyIdAndState } from 'common/utils/instance';
import { getPlanFromSubscriptions, getPlanLimit } from 'common/utils/plans';
import PlansCards from './PlansCards';

const subscribeSubtitle = 'São 5 carteiras prontas e 2 para você personalizar como quiser.';

const updateSubtitle = 'Quanto você deseja investir de capital inicial na carteira?';

const WHITE_BOX_DATA = {
  title:
    'Desbloqueie a criação de carteiras personalizadas e multiplique suas opções de investimento!',
  paragraph:
    'Explore uma variedade de combinações que simplificam suas escolhas e maximizam seu potencial. Crie até duas carteiras exclusivas e acesse nossas carteiras recomendadas, desenvolvidas por especialistas para otimizar sua experiência',
};

const PlanSubscriptionDialog = ({
  classes,
  onClose,
  fullScreen,
  update,
  subscriptions,
  strategyId,
  storeItems,
  instances,
  loadInstanceReport,
  isWhiteBox,
}) => {
  const instanceId = getInstanceByStrategyIdAndState({
    instances: Object.values(instances),
    strategyId,
    state: RUNNING_STATE,
  })?.id;

  useEffect(() => {
    if (instanceId) loadInstanceReport(instanceId);
  }, [instanceId, loadInstanceReport]);

  const storeItem = storeItems[strategyId];
  const { plans } = storeItem.extra_data;

  const getButtonUpgradeParams = (plan) => {
    const currentPlan = getPlanFromSubscriptions({
      subscriptions,
    });
    const signedPlanLimit = getPlanLimit({
      planCode: currentPlan.plan_code,
      listPlans: plans,
    });

    if (plan.extra_data.plan_limit < signedPlanLimit) return PLAN_UPDATE_BUTTON_PARAMS.downgrade;

    if (plan.extra_data.plan_limit > signedPlanLimit) return PLAN_UPDATE_BUTTON_PARAMS.upgrade;

    return PLAN_UPDATE_BUTTON_PARAMS.current;
  };

  const getPlansWithCustomParams = () => {
    const plansData = plans.map((plan) => {
      const params = getButtonUpgradeParams(plan);

      return { ...plan, ...params };
    });

    return plansData;
  };

  return (
    <Dialog open onClose={onClose} maxWidth="md" fullScreen={fullScreen}>
      <CloseDialogButton onClose={onClose} />
      <DialogContent className={classes.content}>
        <Typography variant="h2" align="center" className={classes.title}>
          {isWhiteBox
            ? WHITE_BOX_DATA.title
            : 'Ao assinar a SmarttInvest, você terá acesso completo a todas as carteiras da nossa plataforma!'}
        </Typography>
        {isWhiteBox ? (
          <Typography align="center" className={classes.subtitle}>
            {WHITE_BOX_DATA.paragraph}
          </Typography>
        ) : (
          <Typography align="center" className={classes.subtitle}>
            {update ? updateSubtitle : subscribeSubtitle}
          </Typography>
        )}
        <PlansCards
          plans={update ? getPlansWithCustomParams() : plans}
          onClose={onClose}
          strategyId={strategyId}
          instanceId={instanceId}
          isWhiteBox={isWhiteBox}
        />
      </DialogContent>
    </Dialog>
  );
};

PlanSubscriptionDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  strategyId: PropTypes.number.isRequired,
  instances: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  update: PropTypes.bool,
  subscriptions: PropTypes.array.isRequired,
  storeItems: PropTypes.object.isRequired,
  loadInstanceReport: PropTypes.func.isRequired,
  isWhiteBox: PropTypes.bool,
};

PlanSubscriptionDialog.defaultProps = {
  update: false,
  isWhiteBox: false,
};

export default withMobileDialog()(PlanSubscriptionDialog);
